import React, { Component } from 'react'
import { Switch } from "react-router-dom";
// import { createBrowserHistory } from 'history';
import Dashboard from "./dashboard";
import ChangePassword from "./changePassword";
import EditProfile from "./editProfile";
import PrivateRoute from "./privateRoute";
import Config from "../../helper/config";

const reactUrl = Config.reactUrl + "/coachuser";
// const history = createBrowserHistory();

class CoachUserRouter extends Component {
    render() {
        return (
            <Switch>
                <PrivateRoute exact path={reactUrl + "/dashboard"} component={Dashboard} />
                <PrivateRoute exact path={reactUrl + "/editprofile"} component={EditProfile} />
                <PrivateRoute exact path={reactUrl + "/changepassword"} component={ChangePassword} />
            </Switch>
        )
    }
}
export default CoachUserRouter;